/* eslint-disable */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiUrl } from 'App.js';

export const fetchAsyncCategory1 = createAsyncThunk(
  'category1/get',
  async () => {
    const res = await axios.get(`${apiUrl}category1`);
    // console.log(res.data);
    return res.data;
  }
);

export const fetchAsyncCategory2 = createAsyncThunk(
  'category1/post',
  async (arg, thunkAPI) => {
    const { category1Id, channel } = arg;
    const categoryid = category1Id;
    const res = await axios.post(`${apiUrl}category1`, {
      post_category1: categoryid,
      channel: channel
    });
    return res.data;
  }
);
export const fetchAsyncCategory3 = createAsyncThunk(
  'category2/post',
  async (arg, thunkAPI) => {
    const { category2Id, channel } = arg;
    const categoryid = category2Id;
    const res = await axios.post(`${apiUrl}category2`, {
      post_category2: categoryid,
      channel: channel
    });
    // console.log(res.data);
    return res.data;
  }
);
export const fetchAsyncCategory4 = createAsyncThunk(
  'category3/post',
  async (arg, thunkAPI) => {
    const { category3Id, channel } = arg;
    const categoryid = category3Id;
    const res = await axios.post(`${apiUrl}category3`, {
      post_category3: categoryid,
      channel: channel
    });
    // console.log(res.data);
    return res.data;
  }
);
export const fetchAsyncCategory5 = createAsyncThunk(
  'category4/post',
  async (arg, thunkAPI) => {
    const { category4Id, channel } = arg;
    const categoryid = category4Id;
    const res = await axios.post(`${apiUrl}category4`, {
      post_category4: categoryid,
      channel: channel
    });
    return res.data;
  }
);
export const fetchAsyncCategory6 = createAsyncThunk(
  'category5/post',
  async (arg, thunkAPI) => {
    const { category5Id, channel } = arg;
    const categoryid = category5Id;
    const res = await axios.post(`${apiUrl}category5`, {
      post_category5: categoryid,
      channel: channel
    });
    // console.log(res.data);
    return res.data;
  }
);
export const fetchAsyncLastCategory = createAsyncThunk(
  'category6/post',
  async (arg, thunkAPI) => {
    const { category6Id, channel } = arg;
    const categoryid = category6Id;
    const res = await axios.post(`${apiUrl}category6`, {
      post_category6: categoryid,
      channel: channel
    });
    // console.log(res.data);
    return res.data;
  }
);

const fetchCategorySlice = createSlice({
  name: 'categories',
  initialState: {
    amazonCategories: {
      category1: [],
      category2: [],
      category3: [],
      category4: [],
      category5: [],
      category6: []
    },
    rakutenCategories: {
      category1: [],
      category2: [],
      category3: [],
      category4: [],
      category5: [],
      category6: []
    },
    yahooCategories: {
      category1: [],
      category2: [],
      category3: [],
      category4: [],
      category5: [],
      category6: []
    },
    test :{value: 'aaa', label: 'bbb'}
  },
  reducers: {
    // selectCategory1: (state, action) => {
    //   return {
    //     ...state.category2.otherpteroducts,
    //     otherproducts: action.payload
    //   };
    // 
    changeCategoryLabel: (state, action) => {
      return{
        ...state.test,
        test: action.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncCategory1.fulfilled, (state, action) => {
      return {
        ...state,
        amazonCategories: {
          category1: action.payload.CategoryAmazonResultList,
          category2: [],
          category3: [],
          category4: [],
          category5: [],
          category6: []
        },
        rakutenCategories: {
          category1: action.payload.CategoryRakutenResultList,
          category2: [],
          category3: [],
          category4: [],
          category5: [],
          category6: []
        },
        yahooCategories: {
          category1: action.payload.CategoryYahooResultList,
          category2: [],
          category3: [],
          category4: [],
          category5: [],
          category6: []
        }
      };
    });

    builder.addCase(fetchAsyncCategory2.fulfilled, (state, action) => {
      if (action.payload.CategoryAmazonResultList) {
        return {
          amazonCategories: {
            ...state.amazonCategories,
            category1: state.amazonCategories.category1,
            category2: action.payload.CategoryAmazonResultList,
            category3: [],
            category4: [],
            category5: [],
            category6: []
          },
          rakutenCategories: { ...state.rakutenCategories },
          yahooCategories: { ...state.yahooCategories }
        };
      } else if (action.payload.CategoryRakutenResultList) {
        return {
          rakutenCategories: {
            ...state.rakutenCategories,
            category1: state.rakutenCategories.category1,
            category2: action.payload.CategoryRakutenResultList,
            category3: [],
            category4: [],
            category5: [],
            category6: []
          },
          amazonCategories: { ...state.amazonCategories },
          yahooCategories: { ...state.yahooCategories }
        };
      } else if (action.payload.CategoryYahooResultList.length !== 0) {
        return {
          yahooCategories: {
            ...state.yahooCategories,
            category1: state.yahooCategories.category1,
            category2: action.payload.CategoryYahooResultList,
            category3: [],
            category4: [],
            category5: [],
            category6: []
          },
          amazonCategories: { ...state.amazonCategories },
          rakutenCategories: { ...state.rakutenCategories }
        };
      }
    });
    builder.addCase(fetchAsyncCategory3.fulfilled, (state, action) => {
      if (action.payload.CategoryAmazonResultList) {
        return {
          amazonCategories: {
            ...state.amazonCategories,
            category1: state.amazonCategories.category1,
            category2: state.amazonCategories.category2,
            category3: action.payload.CategoryAmazonResultList,
            category4: [],
            category5: [],
            category6: []
          },
          rakutenCategories: { ...state.rakutenCategories },
          yahooCategories: { ...state.yahooCategories }
        };
      } else if (action.payload.CategoryRakutenResultList) {
        return {
          rakutenCategories: {
            ...state.rakutenCategories,
            category1: state.rakutenCategories.category1,
            category2: state.rakutenCategories.category2,
            category3: action.payload.CategoryRakutenResultList,
            category4: [],
            category5: [],
            category6: []
          },
          amazonCategories: { ...state.amazonCategories },
          yahooCategories: { ...state.yahooCategories }
        };
      } else if (action.payload.CategoryYahooResultList) {
        return {
          yahooCategories: {
            ...state.yahooCategories,
            category1: state.yahooCategories.category1,
            category2: state.yahooCategories.category2,
            category3: action.payload.CategoryYahooResultList,
            category4: [],
            category5: [],
            category6: []
          },
          amazonCategories: { ...state.amazonCategories },
          rakutenCategories: { ...state.rakutenCategories }
        };
      }
    });
    builder.addCase(fetchAsyncCategory4.fulfilled, (state, action) => {
      if (action.payload.CategoryAmazonResultList) {
        return {
          amazonCategories: {
            ...state.amazonCategories,
            category1: state.amazonCategories.category1,
            category2: state.amazonCategories.category2,
            category3: state.amazonCategories.category3,
            category4: action.payload.CategoryAmazonResultList,
            category5: [],
            category6: []
          },
          rakutenCategories: { ...state.rakutenCategories },
          yahooCategories: { ...state.yahooCategories }
        };
      } else if (action.payload.CategoryRakutenResultList) {
        return {
          rakutenCategories: {
            ...state.rakutenCategories,
            category1: state.rakutenCategories.category1,
            category2: state.rakutenCategories.category2,
            category3: state.rakutenCategories.category3,
            category4: action.payload.CategoryRakutenResultList,
            category5: [],
            category6: []
          },
          amazonCategories: { ...state.amazonCategories },
          yahooCategories: { ...state.yahooCategories }
        };
      } else if (action.payload.CategoryYahooResultList) {
        return {
          yahooCategories: {
            ...state.yahooCategories,
            category1: state.yahooCategories.category1,
            category2: state.yahooCategories.category2,
            category3: state.yahooCategories.category3,
            category4: action.payload.CategoryYahooResultList,
            category5: [],
            category6: []
          },
          amazonCategories: { ...state.amazonCategories },
          rakutenCategories: { ...state.rakutenCategories }
        };
      }
    });
    builder.addCase(fetchAsyncCategory5.fulfilled, (state, action) => {
      if (action.payload.CategoryAmazonResultList) {
        return {
          amazonCategories: {
            ...state.amazonCategories,
            category1: state.amazonCategories.category1,
            category2: state.amazonCategories.category2,
            category3: state.amazonCategories.category3,
            category4: state.amazonCategories.category4,
            category5: action.payload.CategoryAmazonResultList,
            category6: []
          },
          rakutenCategories: { ...state.rakutenCategories },
          yahooCategories: { ...state.yahooCategories }
        };
      } else if (action.payload.CategoryRakutenResultList) {
        return {
          rakutenCategories: {
            ...state.rakutenCategories,
            category1: state.rakutenCategories.category1,
            category2: state.rakutenCategories.category2,
            category3: state.rakutenCategories.category3,
            category4: state.rakutenCategories.category4,
            category5: action.payload.CategoryRakutenResultList,
            category6: []
          },
          amazonCategories: { ...state.amazonCategories },
          yahooCategories: { ...state.yahooCategories }
        };
      } else if (action.payload.CategoryYahooResultList) {
        return {
          yahooCategories: {
            ...state.yahooCategories,
            category1: state.yahooCategories.category1,
            category2: state.yahooCategories.category2,
            category3: state.yahooCategories.category3,
            category4: state.yahooCategories.category4,
            category5: action.payload.CategoryYahooResultList,
            category6: []
          },
          amazonCategories: { ...state.amazonCategories },
          rakutenCategories: { ...state.rakutenCategories }
        };
      }
    });
    builder.addCase(fetchAsyncLastCategory.fulfilled, (state, action) => {
      if (action.payload.CategoryAmazonResultList) {
        return {
          amazonCategories: {
            ...state.amazonCategories,
            category1: state.amazonCategories.category1,
            category2: state.amazonCategories.category2,
            category3: state.amazonCategories.category3,
            category4: state.amazonCategories.category4,
            category5: state.amazonCategories.category5,
            category6: action.payload.CategoryAmazonResultList
          },
          rakutenCategories: { ...state.rakutenCategories },
          yahooCategories: { ...state.yahooCategories }
        };
      } else if (action.payload.CategoryRakutenResultList) {
        return {
          rakutenCategories: {
            ...state.rakutenCategories,
            category1: state.rakutenCategories.category1,
            category2: state.rakutenCategories.category2,
            category3: state.rakutenCategories.category3,
            category4: state.rakutenCategories.category4,
            category5: state.rakutenCategories.category5,
            category6: action.payload.CategoryRakutenResultList
          },
          amazonCategories: { ...state.amazonCategories },
          yahooCategories: { ...state.yahooCategories }
        };
      } else if (action.payload.CategoryYahooResultList) {
        return {
          yahooCategories: {
            ...state.yahooCategories,
            category1: state.yahooCategories.category1,
            category2: state.yahooCategories.category2,
            category3: state.yahooCategories.category3,
            category4: state.yahooCategories.category4,
            category5: state.yahooCategories.category5,
            category6: action.payload.CategoryYahooResultList
          },
          amazonCategories: { ...state.amazonCategories },
          rakutenCategories: { ...state.rakutenCategories }
        };
      }
    });
  }
});

// export const {
//   selectCategory1
// } = fetchCategoryGraphSlice.actions;

export const amazonCategory = (state) => state.categories.amazonCategories;
export const rakutenCategory = (state) => state.categories.rakutenCategories;
export const yahooCategory = (state) => state.categories.yahooCategories;
export const testCategory = (state) => state.categories.test;

export const { changeCategoryLabel } = fetchCategorySlice.actions;

export default fetchCategorySlice.reducer;
